import angular from 'angular';
import { changePageTitle } from 'auth/actions/session.actions';
import AnnouncementsWidgetComponent from './announcements-widget-component';
import AnnouncementsWidgetContentComponent from './announcements-widget-content-component';

import announcementsManagementModule from './components/announcement-management/announcements-management-module';

export default angular
  .module('announcements', [announcementsManagementModule.name])
  .component('announcementsWidget', new AnnouncementsWidgetComponent())
  .component('announcementsWidgetContent', new AnnouncementsWidgetContentComponent())
  .config([
    '$stateProvider',
    function configure($stateProvider) {
      $stateProvider
        .state('cms-newsManagement', {
          parent: 'arw',
          url: '/cms-announcements-management',
          template: '<announcement-management></announcement-management>',
          params: {
            skipReloadData: false,
            skipDirtyForms: false,
            pageTitle: [
              '$ngRedux',
              'gettextCatalog',
              ($ngRedux, gettextCatalog) => {
                $ngRedux.dispatch(changePageTitle(gettextCatalog.getString('Manage Lottery Announcements')));
              },
            ],
          },
          redirectTo: 'permissions-denied',
        })
        .state('cms-editNewsManagement', {
          parent: 'arw',
          url: '/announcement-edit/{id:[0-9]*}/{type}',
          template: '<announcement-form></announcement-form>',
          redirectTo: 'permissions-denied',
          params: {
            skipDirtyForms: false,
          },
          resolve: {
            api: [
              '$ngRedux',
              '$stateParams',
              'gettextCatalog',
              ($ngRedux, $stateParams, gettextCatalog) => {
                $ngRedux.dispatch(
                  changePageTitle(
                    $stateParams.id
                      ? gettextCatalog.getString('Edit Lottery Announcement')
                      : gettextCatalog.getString('Create Lottery Announcement')
                  )
                );
              },
            ],
          },
        });
    },
  ]);



// WEBPACK FOOTER //
// ./src/modules/dashboard/components/dashboard-widget/announcements/announcements-module.js